// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-point-box {
  border: 2px solid var(--ion-color-medium);
  width: 80px;
  height: 80px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin: 20px auto 0;
}

.impact-score-box {
  border: 2px solid var(--ion-color-warning);
  width: 100px;
  height: 100px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin: 0 auto;
}

.member-box {
  border: 2px solid var(--ion-color-medium);
  width: 80px;
  height: 80px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin: 20px auto 0 auto;
}

.action-point-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -10px;
  position: absolute;
  margin-left: -15px;
  width: 32px;
}

.member-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -10px;
  position: absolute;
  margin-left: -15px;
  width: 32px;
}

.impact-score-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -10px;
  position: absolute;
  margin-left: -15px;
  width: 32px;
}

.score-heading {
  text-align: center;
  color: var(--ion-color-medium);
}

.score-content {
  position: relative;
  margin-top: -80px;
  padding-bottom: 21px;
  color: var(--ion-color-medium);
}

.score-content-center {
  font-size: 16px;
  text-align: center;
  position: relative;
  margin-top: 20px;
}

.score-content-center-two {
  font-size: 15px;
  color: var(--ion-color-warning);
  text-align: center;
}

.score-text {
  margin-top: 15px;
}

hr {
  padding: 0;
  width: 50%;
  margin: 0 auto;
  background: var(--ion-color-warning);
}

.impact_score_txt {
  color: var(--ion-color-warning);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
